export const getMapboxCountry = (feature: any) => {
  const context = feature?.properties?.context || {}
  const country =
    context?.country ||
    (Array.isArray(context)
      ? context.find((item: any) =>
          String(item?.id || item?.mapbox_id || '').includes('country')
        )
      : null)

  const name = String(
    country?.name ||
      country?.name_preferred ||
      feature?.properties?.country ||
      ''
  ).trim()

  const code = String(
    country?.country_code ||
      country?.short_code ||
      feature?.properties?.country_code ||
      ''
  )
    .trim()
    .toUpperCase()

  return {
    countryName: name || undefined,
    countryCode: code || undefined
  }
}
